import BuyerApi from '../helpers/buyer-api';
import { CloseBarkConfirmModal } from '../components/close-bark-modal/close-bark-confirm-modal';

export default function () {
	const buyerApi = BuyerApi();
	const { Handlebars, bugsnagClient, Bark } = window;
	const closeBarkConfirmModal = CloseBarkConfirmModal();

	const state = {
		nextPage: undefined,
		prevPage: undefined,
		buyer: null,
	};

	const getAllDataForPage = () => {
		buyerApi
			.getSelfPromise()
			.then((resp) => {
				state.buyer = resp.data;
				renderPage(state.buyer);
			})
			.catch((error) => {
				handleApiError(error);
			});
	};

	const handleApiError = (error) => {
		bugsnagClient.notify(new Error('Failed to get project list data'), {
			metaData: error,
		});
		state.nextPage = null;
		window.hideLoading();
	};

	const renderSellerBanner = () => {
		let banner = Handlebars.compile($('#seller-signup-banner').html());
		$('.seller-banner-wrapper').append(banner());
	};

	const bindListeners = () => {
		$('#buyer-dashboard').on('click', '.js-clickable-header', function () {
			window.location.href = $(this).data('href');
		});

		$('body').on('click', '#__rctBuyerPlist .category-link', function (e) {
			e.preventDefault();
			$('.modal').modal('hide');
			$('#category_id').val($(this).data('category-id'));
			$('#postcode_id').val('-1');
			$('#postcode_type').val('-1');
			$('#category_name_hidden').val('');
			$('#bark_mode').val($(this).data('bark-mode') ?? 'bnb-card');
			$('#bark_submit').trigger('click');
		});
	};

	const getNextBarkSuggestions = () => {
		return new Promise((resolve, reject) => {
			buyerApi.getNextBarkSuggestions((data) => {
				resolve(data.data);
			}, reject);
		});
	};

	const checkCloseBarkConfirmModal = () => {
		let param = Bark.GET('close-bark-confirm');
		if (param) {
			Bark.removeParamFromUrl('close-bark-confirm');
			getNextBarkSuggestions().then((data) => {
				closeBarkConfirmModal.renderModal(param, data);
			});
		}
	};

	const renderPage = (buyer, isLoadMore) => {
		var wrapper = $('div#buyer-dashboard .full-width-wrapper');
		wrapper.removeClass('full-height-with-header');

		if (!isLoadMore) {
			if (!buyer.is_seller) {
				renderSellerBanner();
			}
		}
	};

	checkCloseBarkConfirmModal();
	getAllDataForPage();

	bindListeners();
}
